import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.cashapp_merchant_order,
    props.app.buttons.create_cashapp_merchant_order,
    (order, button) => {
        return {
            order,
            button
        }
    }
)